/**
 * Image component for local and deployed environments.
 *
 * The previous responsive `srcSet` pointed at Vercel's `/_vercel/image`
 * endpoint, which is not provisioned by this deployment and caused browsers
 * to choose broken image URLs. Serve the original optimized assets directly.
 */

interface ImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  src: string;
  alt: string;
  sizes?: string;
  quality?: number;
}

export function Image({
  src,
  alt,
  sizes: _sizes = "100vw",
  quality: _quality = 75,
  loading = "lazy",
  className,
  ...rest
}: ImageProps) {
  return (
    <img
      src={src}
      alt={alt}
      className={className}
      loading={loading}
      {...rest}
    />
  );
}
